import React from 'react';
import cx from 'classnames';
import Icon, { IconName } from 'app/common/components/controls/icon';
import { forNamespace, forTemplate } from 'app/common/lib/util/i18n';
import styles from './AnnouncementsFooter.less';
import { trackUe, Noun, Verb } from '@trello/analytics';

const format = forTemplate('header_announcements');
const socialUrls = forNamespace('social');

const trackSocialClick = (socialUrl: string) => () => {
  trackUe({
    category: Noun.HEADER,
    verb: Verb.OPENS,
    directObj: Noun.LANDING_TAB,
    context: {
      landingTab: socialUrl,
    },
  });
};

interface AnnouncementsFooterProps {
  highlightedUrl?: string | null;
}

export const AnnouncementsFooter: React.FC<AnnouncementsFooterProps> = ({
  highlightedUrl,
}) => {
  const blogUrl = new URL(socialUrls('blog'));
  blogUrl.searchParams.append('utm_campaign', 'none');
  blogUrl.searchParams.append('utm_source', 'direct');
  blogUrl.searchParams.append('utm_medium', 'inapp');

  if (highlightedUrl) {
    const url = new URL(highlightedUrl);
    if (url.host.includes('blog.trello.com')) {
      if (url.searchParams.has('utm_campaign')) {
        blogUrl.searchParams.set(
          'utm_campaign',
          url.searchParams.get('utm_campaign')!,
        );
      } else {
        const paths = url.pathname.split('/');
        if (paths.length > 0) {
          blogUrl.searchParams.set('utm_campaign', paths[paths.length - 1]);
        }
      }

      if (url.searchParams.has('utm_source')) {
        blogUrl.searchParams.set(
          'utm_source',
          url.searchParams.get('utm_source')!,
        );
      }
    }
  }

  return (
    <footer className={styles.footerLinks}>
      <p className={cx(styles.quiet, styles.footerMessage)}>
        {format('for-more-updates-check-out-ellipsis')}
      </p>

      <a
        className={styles.blogLink}
        target="_blank"
        rel="noopener noreferrer"
        href={blogUrl.toString()}
        onClick={trackSocialClick('blog')}
      >
        <Icon className={styles.blogIcon} name={IconName.Board} large />
        <span className={styles.underline}>{format('trello-blog')}</span>
      </a>

      <a
        className={styles.socialMediaLink}
        target="_blank"
        rel="noopener noreferrer"
        href={socialUrls('twitter')}
        onClick={trackSocialClick('twitter')}
      >
        <Icon name={IconName.Twitter} large />
      </a>
      <a
        className={styles.socialMediaLink}
        target="_blank"
        rel="noopener noreferrer"
        href={socialUrls('facebook')}
        onClick={trackSocialClick('facebook')}
      >
        <Icon name={IconName.Facebook} large />
      </a>
      <a
        className={styles.socialMediaLink}
        target="_blank"
        rel="noopener noreferrer"
        href={socialUrls('instagram')}
        onClick={trackSocialClick('instagram')}
      >
        <Icon name={IconName.Instagram} large />
      </a>
    </footer>
  );
};
